let lastConnectId = null;

export function setLastConnectId(connectId) {
  lastConnectId = connectId || null;
}

export function getLastConnectId() {
  return lastConnectId;
}

export function clearLastConnectId() {
  lastConnectId = null;
}
